import { HeartHandshake, ShieldPlus, Clock } from "lucide-react";
import { Reveal } from "../lib/motion";

const INTRO_IMG =
  "https://static.prod-images.emergentagent.com/jobs/dc8a482d-361d-4996-9eb5-a4cbac9ec941/images/452ff7d84a28c51bcec4c7df20efb2e8e31891afed9a5ba3051c8b3e522926f1.jpeg";

const TRUST = [
  { icon: HeartHandshake, title: "Recovery-informed drivers", note: "Personal or professional experience with substance use disorder and recovery." },
  { icon: ShieldPlus, title: "Narcan trained and equipped", note: "Prepared to respond to opioid-overdose emergencies." },
  { icon: Clock, title: "Immediate and scheduled service", note: "Available 24/7, depending on driver availability." },
];

export const Introduction = () => (
  <section id="intro" className="relative bg-[#FAFAF9] py-20 sm:py-28">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
      <Reveal className="relative order-2 lg:order-1">
        <div className="relative rounded-[2rem] rounded-tl-[4rem] overflow-hidden shadow-xl shadow-[#3B3A4E]/15 aspect-square bg-[#F5F4F1]">
          <img
            src={INTRO_IMG}
            alt="Illustration of Michael driving and speaking with a reassuring smile to a calm adult passenger inside the car"
            className="h-full w-full object-cover"
          />
        </div>
        <div className="pointer-events-none absolute -z-10 -bottom-6 -right-6 h-40 w-40 rounded-full bg-[#1AD1B9]/20 blur-2xl" />
      </Reveal>

      <div className="order-1 lg:order-2">
        <Reveal>
          <p className="text-xs sm:text-sm uppercase tracking-[0.2em] font-semibold text-[#0891B2] mb-4">
            More than a ride
          </p>
          <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#3B3A4E] leading-tight">
            Not Just Transportation. A Recovery-Informed Concierge Service.
          </h2>
        </Reveal>
        <Reveal delay={0.08}>
          <div className="mt-6 space-y-4 text-base sm:text-lg text-[#5C5975] leading-relaxed">
            <p>
              When an individual makes the incredible decision to change their life, the trip from Point A to
              Point B is often overlooked. During that trip, they may be alone with their thoughts, fears, and
              uncertainty.
            </p>
            <p>
              Recovery Rides makes sure every passenger knows they are making the right decision—and, more
              importantly, that they are <span className="font-semibold text-[#2D2B3D]">worth the ride</span>.
            </p>
            <p>
              Our drivers understand substance use disorder and recovery through personal experience,
              professional experience, or both. We are honored to sometimes be the first face of recovery a
              person meets and to help set a positive, encouraging tone before they arrive at treatment.
            </p>
          </div>
        </Reveal>

        <div className="mt-8 grid sm:grid-cols-3 gap-4">
          {TRUST.map((t, i) => (
            <Reveal key={t.title} delay={0.12 + i * 0.08}>
              <div className="h-full rounded-2xl bg-white border border-[#3B3A4E]/8 p-5 shadow-sm transition-all duration-300 hover:shadow-lg hover:-translate-y-1">
                <div className="h-10 w-10 rounded-xl bg-[#E6FFFA] flex items-center justify-center mb-3">
                  <t.icon size={20} className="text-[#0891B2]" />
                </div>
                <h3 className="text-sm font-semibold text-[#2D2B3D]">{t.title}</h3>
                <p className="mt-1 text-sm text-[#5C5975] leading-snug">{t.note}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
